import ProductSearch from './components/product_search.js';
(function() {
    document.querySelector('[data-search-button]').addEventListener('click', function() {
        document.querySelector('[data-product-search-input]').focus();
    });
    if (document.querySelector('[data-product-search-container]')) {
        new ProductSearch();
    }
})();
